// apps/web/src/features/projects/wizard/useNextProjectCode.ts
import { useMemo } from 'react';
import { suggestNextCode } from '../validators';

/**
 * Given the list of existing projects (already loaded by useProjectsHubData),
 * computes the next available PYYXXX code for the current year.
 */
export function useNextProjectCode(
  existingProjects: readonly { id: string; code: string }[],
): string {
  return useMemo(
    () => suggestNextCode(existingProjects),
    [existingProjects],
  );
}
